import { useState, useEffect } from 'react';

/**
 * Header Component
 *
 * @param params
 * @returns {JSX.Element}
 * @constructor
 */
function Header(params) {
  const [showBackButton, setShowBackButton] = useState(false);
  const player = JSON.parse(localStorage.getItem('player'));

  const disableBackButton = params.disableBackButton ?? false;

  /**
   * Init back button visibility
   */
  useEffect(() => {
    if (window.location.pathname !== '/') {
      setShowBackButton(true);
    }
  }, []);

  /**
   * onBackClick
   *
   * Handler for the back button.
   */
  const onBackClick = () => {
    if (!disableBackButton) {
      if (window.location.pathname.includes('/dashboard')) {
        // Always go home from the dashboard
        window.location = '/';
      } else if (window.location.pathname.includes('/stats') ||
                 window.location.pathname.includes('/invite') ||
                 window.location.pathname.includes('/play'))
      {
        window.location = '/dashboard';
      } else {
        window.history.back();
      }
    }
  }

  return (
    <header className="app-header">
      <div className="logo-wrap">
        <img src="/header_logo.png" className="logo-header" alt="TrivAi" onClick={() => window.location = '/dashboard'}/>
        <div className="trade-mark-header">&trade;</div>
      </div>
      {showBackButton && !disableBackButton &&
        <svg className="back-icon-svg" onClick={onBackClick}
             viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M563.2 715.946667a33.9968 33.9968 0 0 1-24.132267-10.001067l-170.666666-170.666667a34.133333 34.133333 0 0 1 0-48.264533l170.666666-170.666667a34.133333 34.133333 0 1 1 48.264534 48.264534l-146.517334 146.5344 146.517334 146.5344A34.133333 34.133333 0 0 1 563.2 715.946667z"/>
        </svg>
      }
      {player?.email &&
        <img src="/profile-icon.svg" className="profile-icon" alt="profile"
             onClick={() => window.location = "/profile"}/>
      }
      {!player?.email &&
        <img src="/icon2.svg" className="profile-icon help-icon" alt="profile"
             onClick={() => window.location = "/profile"}/>
      }
    </header>
  )
}

export default Header;
